export default __webpack_public_path__ + "static/media/aab44f382271ca777d59c5c9d2cc55d21598720765203.1fbefda2.webp";